import React, { useContext } from 'react'
import { Context } from 'Context/Context'
import ChangePassword from 'Components/Profile/ChangePassword'
import AddUser from './AddUser'
import PlainEmailNotifications from 'Components/Profile/PlainEmailNotifications'

// Same content padding as the attorney profile tabs (ProfilePageRedirect).
// PlainEmailNotifications pads itself, so it isn't wrapped.
const padded = (el) => <div className='px-4 py-6 lg:px-10 lg:py-[34px]'>{el}</div>

function AdminProfileRedirect({activePanel, setActivePanel}) {
    const {userDetails} = useContext(Context)
    const builder = () => {
        switch(parseInt(activePanel))
        {
            case 0:
                return padded(userDetails?.isAdminAssistant ? <ChangePassword/> :  <AddUser/> )
            case 1:
                return padded(<ChangePassword/>)
            case 2:
                return <PlainEmailNotifications/>
            default:

                return <></>
        }
    }
  return (
    <div className='h-full w-full bg-white min-h-[800px]'>{builder()}</div>
  )
}

export default AdminProfileRedirect
